import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CheckboxField } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import styles from './ActivityAdvancedFilter.module.scss';

const FilterOptions = (props) => {
    const { filters, onValueChange } = props;
    const writeValue = (value, path) => {
        filters.options[path].selected = value;
        if (onValueChange) {
            onValueChange(filters);
        }
    };
    const translator = useContext(TranslatorContext);
    return (
        <Fragment>
            {filters.options.map((option, index) => {
                const fieldId = option.displayKey.id || option.displayKey;
                return (
                    <div className={styles.gwFilterOption} key={fieldId}>
                        <CheckboxField
                            id={fieldId}
                            value={option.selected}
                            path={index}
                            showInlineLabel
                            label={translator(option.displayKey)}
                            showOptional={false}
                            onValueChange={writeValue}
                            labelClassName={styles.gwActivityFilterOptionsLabel}
                        />
                    </div>
                );
            })}
        </Fragment>
    );
};

FilterOptions.propTypes = {
    filters: PropTypes.shape({
        options: PropTypes.shape([])
    }).isRequired,
    onValueChange: PropTypes.func.isRequired
};
export default FilterOptions;
